import { AUTOMATION_CONTEXT_OUTCOME, AUTOMATION_CONTEXT_STEP } from '@components/PositionAutomation/helper';

const EMPTY_LINKS = Object.freeze({});
const EMPTY_LIST = Object.freeze([]);

export const selectEditor = (state) => {
    const editor = state.automationEditor;
    return {
        data: editor.data,
        loading: editor.loading,
        error: editor.error,
        loaded: editor.loaded,
    };
};

export const selectConfigs = (state) => {
    const c = state.automationConfigs;
    return {
        data: c.data,
        loading: c.loading,
        error: c.error,
    };
};

export const selectEditorLoaded = (state) => {
    const editor = state.automationEditor;
    return editor.loaded;
};

export const selectAutomationRules = (state) => state.automationEditor.data?.automation_rules ?? EMPTY_LIST;

export const selectEditorLinks = (state) => state.automationEditor.data?._links ?? EMPTY_LINKS;

export const selectAutomationActions = (state) => state.automationConfigs.data?.actions ?? EMPTY_LIST;

export const selectCanAddAutomation = (state) => {
    const links = state.automationEditor.data?._links;
    const actions = state.automationConfigs.data?.actions;
    return Boolean(links?.post && actions?.length > 0);
};

export const selectRulesByStep = (state) => state.rulesByStep;

export const selectRulesByOutcome = (state) => state.rulesByOutcome;

export const makeSelectRulesForContext = (contextId, isOutcome = false) => (state) => {
    const bucket = isOutcome ? state.rulesByOutcome : state.rulesByStep;
    return bucket[contextId] ?? EMPTY_LIST;
};

export const selectAutomationModal = (state) => state.ui.automationModal;

export const selectAutomationRuleForm = (state) => state.ui.automationRuleForm;

export const selectAutomationRuleSaving = (state) => state.ui.automationRuleSaving;

export const selectResolvedSelectedAction = (state) => {
    const modal = state.ui.automationModal;
    if (!modal) {
        return null;
    }
    const configs = state.automationConfigs.data;
    const ruleDetail = modal.ruleDetail;
    const selectedAction = modal.selectedAction;
    if (ruleDetail?.action?.id && configs?.actions) {
        return configs.actions.find((a) => a.id === ruleDetail.action.id) ?? null;
    }
    return selectedAction ?? null;
};

export const selectSaveTarget = (state) => {
    const { ruleDetail, category, contextId } = state.ui.automationModal ?? {};
    if (ruleDetail?.outcome != null) {
        return { category: AUTOMATION_CONTEXT_OUTCOME, contextId: ruleDetail.outcome };
    }
    if (ruleDetail?.applicant_step != null) {
        return { category: AUTOMATION_CONTEXT_STEP, contextId: ruleDetail.applicant_step };
    }
    return { category, contextId };
};

export const selectFetchingRuleId = (state) => state.ui.fetchingRuleId;

export const selectActionResources = (state) => {
    const r = state.actionResources;
    return {
        data: r.data,
        loading: r.loading,
        error: r.error,
        actionId: r.actionId,
    };
};
